// extracted by mini-css-extract-plugin
export default {"extensionButton":"HeaderExtensionsList-module__extensionButton___Sn4iF"};